import { Measure } from '@fullstory/proto/fs/api/metrics';
import { TimeInterval } from '@fullstory/proto/fs/api/segment';
import { Visibility } from '@fullstory/proto/fs/gcloud/dstore/protoauditstore';
import { QueryCacheOptions } from '@fullstory/proto/fs/services/alexa';
import {
  ComputeMetricResponse,
  GetAllMetricsResponse,
} from '@fullstory/proto/fs/services/dx-objects';
import { Duration, Timestamp, int64, timestamp } from '@fullstory/proto/google/protobuf';
import { ComputeMetricResponseWithId } from '@fullstory/redux';

export const COMPUTE_METRIC_RESPONSE: ComputeMetricResponse = {
  responses: [
    {
      response: {
        data: {
          table: [],
          numGroups: int64.zero,
        },
        computedAt: Timestamp.now(),
        backgroundRefId: '',
        sampleResults: null,
        resultStatus: null,
      },
      isTimeRangeComparison: false,
    },
  ],
  cacheOption: {
    getIfAgeLessThan: Duration.fromMillis(12 * 3600000),
    computeIfOlderThan: Duration.fromMillis(3600000), // hour
    skipCache: false,
    queue: QueryCacheOptions.Queue.QUEUE_INVALID,
  },
};

export const COMPUTE_METRIC_RESPONSE_WITH_RESULTS: ComputeMetricResponse = {
  responses: [
    {
      response: {
        data: {
          table: [
            {
              startTime: '2024-07-25T04:00:00Z' as timestamp,
              endTime: '2024-07-26T04:00:00Z' as timestamp,
              groups: [
                {
                  groupId: 'fHU2SLTPiaHP',
                  fallback: false,
                },
              ],
              value: 9074,
              defaultValue: 0,
              isPartialPeriod: false,
            },
          ],
          numGroups: int64.zero,
        },
        computedAt: null,
        backgroundRefId: '',
        sampleResults: null,
        resultStatus: null,
      },
      isTimeRangeComparison: false,
    },
  ],
  cacheOption: null,
};

export const DIMENSIONALITY_METRIC_RESPONSE: ComputeMetricResponseWithId = {
  data: {
    table: [
      {
        startTime: '2021-06-08T04:00:00Z' as timestamp,
        endTime: '2021-07-08T04:00:00Z' as timestamp,
        groups: [{ groupId: 'Chrome', fallback: false }],
        id: '1',
        value: 134270,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-06-08T04:00:00Z' as timestamp,
        endTime: '2021-07-08T04:00:00Z' as timestamp,
        groups: [{ groupId: 'Safari', fallback: false }],
        id: '2',
        value: 15902,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-06-08T04:00:00Z' as timestamp,
        endTime: '2021-07-08T04:00:00Z' as timestamp,
        groups: [{ groupId: 'Firefox', fallback: false }],
        id: '3',
        value: 6252,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-06-08T04:00:00Z' as timestamp,
        endTime: '2021-07-08T04:00:00Z' as timestamp,
        groups: [{ groupId: 'Unknown', fallback: false }],
        id: '4',
        value: 5144,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-06-08T04:00:00Z' as timestamp,
        endTime: '2021-07-08T04:00:00Z' as timestamp,
        groups: [{ groupId: 'Microsoft Edge', fallback: false }],
        id: '5',
        value: 3229,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-06-08T04:00:00Z' as timestamp,
        endTime: '2021-07-08T04:00:00Z' as timestamp,
        groups: [{ groupId: 'Mobile App', fallback: false }],
        id: '6',
        value: 2145,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-06-08T04:00:00Z' as timestamp,
        endTime: '2021-07-08T04:00:00Z' as timestamp,
        groups: [{ groupId: 'Opera', fallback: false }],
        id: '7',
        value: 1517,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-06-08T04:00:00Z' as timestamp,
        endTime: '2021-07-08T04:00:00Z' as timestamp,
        groups: [{ groupId: 'Internet Explorer', fallback: false }],
        id: '8',
        value: 902,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-06-08T04:00:00Z' as timestamp,
        endTime: '2021-07-08T04:00:00Z' as timestamp,
        groups: [{ groupId: 'Yandex', fallback: false }],
        id: '9',
        value: 51,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-06-08T04:00:00Z' as timestamp,
        endTime: '2021-07-08T04:00:00Z' as timestamp,
        groups: [{ groupId: 'Robot', fallback: false }],
        id: '10',
        value: 1,
        defaultValue: 0,
        isPartialPeriod: false,
      },
    ],
    numGroups: '0' as int64,
  },
  computedAt: Timestamp.now(),
  backgroundRefId: '',
  sampleResults: null,
  resultStatus: null,
  isPast: false,
  cacheOptions: null,
};

export const TRENDS_METRIC_RESPONSE: ComputeMetricResponseWithId = {
  data: {
    table: [
      {
        startTime: '2021-06-13T04:00:00Z' as timestamp,
        endTime: '2021-06-14T04:00:00Z' as timestamp,
        groups: [],
        id: '1',
        value: 3383,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-06-14T04:00:00Z' as timestamp,
        endTime: '2021-06-15T04:00:00Z' as timestamp,
        groups: [],
        id: '2',
        value: 10191,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-06-15T04:00:00Z' as timestamp,
        endTime: '2021-06-16T04:00:00Z' as timestamp,
        groups: [],
        id: '3',
        value: 10197,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-06-16T04:00:00Z' as timestamp,
        endTime: '2021-06-17T04:00:00Z' as timestamp,
        groups: [],
        id: '4',
        value: 11684,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-06-17T04:00:00Z' as timestamp,
        endTime: '2021-06-18T04:00:00Z' as timestamp,
        groups: [],
        id: '5',
        value: 9586,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-06-18T04:00:00Z' as timestamp,
        endTime: '2021-06-19T04:00:00Z' as timestamp,
        groups: [],
        id: '6',
        value: 7647,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-06-19T04:00:00Z' as timestamp,
        endTime: '2021-06-20T04:00:00Z' as timestamp,
        groups: [],
        id: '7',
        value: 2457,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-06-20T04:00:00Z' as timestamp,
        endTime: '2021-06-21T04:00:00Z' as timestamp,
        groups: [],
        id: '8',
        value: 4143,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-06-21T04:00:00Z' as timestamp,
        endTime: '2021-06-22T04:00:00Z' as timestamp,
        groups: [],
        id: '9',
        value: 10523,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-06-22T04:00:00Z' as timestamp,
        endTime: '2021-06-23T04:00:00Z' as timestamp,
        groups: [],
        id: '10',
        value: 10441,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-06-23T04:00:00Z' as timestamp,
        endTime: '2021-06-24T04:00:00Z' as timestamp,
        groups: [],
        id: '11',
        value: 12224,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-06-24T04:00:00Z' as timestamp,
        endTime: '2021-06-25T04:00:00Z' as timestamp,
        groups: [],
        id: '12',
        value: 9680,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-06-25T04:00:00Z' as timestamp,
        endTime: '2021-06-26T04:00:00Z' as timestamp,
        groups: [],
        id: '13',
        value: 8149,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-06-26T04:00:00Z' as timestamp,
        endTime: '2021-06-27T04:00:00Z' as timestamp,
        groups: [],
        id: '14',
        value: 2248,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-06-27T04:00:00Z' as timestamp,
        endTime: '2021-06-28T04:00:00Z' as timestamp,
        groups: [],
        id: '15',
        value: 4568,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-06-28T04:00:00Z' as timestamp,
        endTime: '2021-06-29T04:00:00Z' as timestamp,
        groups: [],
        id: '16',
        value: 10763,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-06-29T04:00:00Z' as timestamp,
        endTime: '2021-06-30T04:00:00Z' as timestamp,
        groups: [],
        id: '17',
        value: 10543,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-06-30T04:00:00Z' as timestamp,
        endTime: '2021-07-01T04:00:00Z' as timestamp,
        groups: [],
        id: '18',
        value: 12810,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-07-01T04:00:00Z' as timestamp,
        endTime: '2021-07-02T04:00:00Z' as timestamp,
        groups: [],
        id: '19',
        value: 10304,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-07-02T04:00:00Z' as timestamp,
        endTime: '2021-07-03T04:00:00Z' as timestamp,
        groups: [],
        id: '20',
        value: 9126,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-07-03T04:00:00Z' as timestamp,
        endTime: '2021-07-04T04:00:00Z' as timestamp,
        groups: [],
        id: '21',
        value: 2747,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-07-04T04:00:00Z' as timestamp,
        endTime: '2021-07-05T04:00:00Z' as timestamp,
        groups: [],
        id: '22',
        value: 4591,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-07-05T04:00:00Z' as timestamp,
        endTime: '2021-07-06T04:00:00Z' as timestamp,
        groups: [],
        id: '23',
        value: 7056,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-07-06T04:00:00Z' as timestamp,
        endTime: '2021-07-07T04:00:00Z' as timestamp,
        groups: [],
        id: '24',
        value: 11459,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-07-07T04:00:00Z' as timestamp,
        endTime: '2021-07-08T04:00:00Z' as timestamp,
        groups: [],
        id: '25',
        value: 17659,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-07-08T04:00:00Z' as timestamp,
        endTime: '2021-07-09T04:00:00Z' as timestamp,
        groups: [],
        id: '26',
        value: 12222,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-07-09T04:00:00Z' as timestamp,
        endTime: '2021-07-10T04:00:00Z' as timestamp,
        groups: [],
        id: '27',
        value: 10032,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-07-10T04:00:00Z' as timestamp,
        endTime: '2021-07-11T04:00:00Z' as timestamp,
        groups: [],
        id: '28',
        value: 4213,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-07-11T04:00:00Z' as timestamp,
        endTime: '2021-07-12T04:00:00Z' as timestamp,
        groups: [],
        id: '29',
        value: 5859,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: '2021-07-12T04:00:00Z' as timestamp,
        endTime: '2021-07-13T04:00:00Z' as timestamp,
        groups: [],
        id: '30',
        value: 9759,
        defaultValue: 0,
        isPartialPeriod: false,
      },
    ],
    numGroups: '0' as int64,
  },
  computedAt: '2021-07-12T20:10:26.404513755Z' as timestamp,
  backgroundRefId: '',
  sampleResults: null,
  resultStatus: null,
  isPast: false,
  cacheOptions: null,
};

export const COMPUTE_TOP_URL_METRIC_MOCK: ComputeMetricResponse = {
  responses: [
    {
      response: {
        data: {
          table: [
            {
              startTime: '2023-08-12T04:00:00Z' as timestamp,
              endTime: '2023-08-19T04:00:00Z' as timestamp,
              groups: [
                {
                  groupId: 'https://www.fullstory.com/',
                  fallback: false,
                },
              ],
              value: 6938,
              defaultValue: 10709,
              isPartialPeriod: false,
            },
            {
              startTime: '2023-08-12T04:00:00Z' as timestamp,
              endTime: '2023-08-19T04:00:00Z' as timestamp,
              groups: [
                {
                  groupId: 'https://app.fullstory.com/login/?dest=%2Fui%2F',
                  fallback: false,
                },
              ],
              value: 6302,
              defaultValue: 7003,
              isPartialPeriod: false,
            },
            {
              startTime: '2023-08-12T04:00:00Z' as timestamp,
              endTime: '2023-08-19T04:00:00Z' as timestamp,
              groups: [],
              value: 60323,
              defaultValue: 1956194,
              isPartialPeriod: false,
            },
          ],
          numGroups: '0' as int64,
        },
        computedAt: '2023-08-18T12:49:20.282607519Z' as timestamp,
        backgroundRefId: '',
        sampleResults: null,
        resultStatus: {
          partialResults: false,
        },
      },
      isTimeRangeComparison: false,
    },
  ],
  cacheOption: {
    getIfAgeLessThan: Duration.fromMillis(12 * 3600000),
    computeIfOlderThan: Duration.fromMillis(3600000), // hour
    skipCache: false,
    queue: QueryCacheOptions.Queue.QUEUE_INVALID,
  },
};

export const COMPUTE_TOP_PAGE_METRIC_MOCK: ComputeMetricResponse = {
  responses: [
    {
      response: {
        data: {
          table: [
            {
              startTime: '2023-08-12T04:00:00Z' as timestamp,
              endTime: '2023-08-19T04:00:00Z' as timestamp,
              groups: [
                {
                  groupId: '4151',
                  fallback: false,
                },
              ],
              value: 476322,
              defaultValue: 476322,
              isPartialPeriod: false,
            },
            {
              startTime: '2023-08-12T04:00:00Z' as timestamp,
              endTime: '2023-08-19T04:00:00Z' as timestamp,
              groups: [
                {
                  groupId: '968',
                  fallback: false,
                },
              ],
              value: 398630,
              defaultValue: 398630,
              isPartialPeriod: false,
            },
            {
              startTime: '2023-08-12T04:00:00Z' as timestamp,
              endTime: '2023-08-19T04:00:00Z' as timestamp,
              groups: [],
              value: 1630078,
              defaultValue: 1630078,
              isPartialPeriod: false,
            },
          ],
          numGroups: '0' as int64,
        },
        computedAt: '2023-08-18T12:49:17.695330235Z' as timestamp,
        backgroundRefId: '',
        sampleResults: null,
        resultStatus: {
          partialResults: false,
        },
      },
      isTimeRangeComparison: false,
    },
  ],
  cacheOption: {
    getIfAgeLessThan: Duration.fromMillis(12 * 3600000),
    computeIfOlderThan: Duration.fromMillis(3600000), // hour
    skipCache: false,
    queue: QueryCacheOptions.Queue.QUEUE_INVALID,
  },
};

// TODO(kmorgannn): use a mock generator to generate this
const date = Timestamp.now();
export const GET_ALL_METRICS_MOCK: GetAllMetricsResponse = {
  metrics: [
    {
      metric: {
        metric: {
          id: '12',
          name: 'metric name',
          description: 'metric description',
          metric: {
            single: {
              event: {
                primary: null,
                deps: [],
              },
              aggregation: {},
              rollingWindow: 0,
              rollingWindowType: Measure.RollingWindowType.ROLLING_WINDOW_TYPE_INVALID,
              rollingWindowInterval: TimeInterval.TIME_INTERVAL_INVALID,
            },
          },
          funnelFilter: null,
        },
        metadata: {
          lastUpdated: date,
          lastUpdatedBy: 'fs engineer',
          created: date,
          createdBy: 'fs engineer',
          archived: false,
          visibility: Visibility.PUBLIC,
          version: '1' as int64,
          sequentialVersion: '1' as int64,
        },
        isDcmCreated: false,
        isCanned: false,
      },
      starred: false,
      lastViewed: date,
      canned: false,
    },
    {
      metric: {
        metric: {
          id: '123',
          name: 'metric name',
          description: 'metric description',
          metric: {},
          funnelFilter: null,
        },
        metadata: {
          lastUpdated: date,
          lastUpdatedBy: 'fs engineer',
          created: date,
          createdBy: 'fs engineer',
          archived: false,
          visibility: Visibility.PUBLIC,
          version: '1' as int64,
          sequentialVersion: '1' as int64,
        },
        isDcmCreated: false,
        isCanned: false,
      },
      starred: false,
      lastViewed: date,
      canned: false,
    },
  ],
  pageInfo: null,
};
